import { AnyAction } from '@reduxjs/toolkit';
import { combineEpics, StateObservable } from 'redux-observable';
import { concatMap, distinctUntilChanged, filter, map, Observable, switchMap } from 'rxjs';
import { SmoEnvironment } from '../../../../../Models/Smo/SmoEnvironment';
import { ImageClassifier } from '../../../../ImageClassifier/ImageClassifier';
import WidgetFrontActions from '../../../Pages/WidgetFront/WidgetFrontActions';
import { StoreDependencies } from '../../StoreDependencies';
import { StoreState } from '../../StoreState';
import VideoAnalysisActions from '../VideoAnalysisActions';

function predictEnvironment(
  $action: Observable<AnyAction>,
  _$state: StateObservable<StoreState>,
  dependencies: Partial<StoreDependencies>
): Observable<AnyAction> {
  return $action.pipe(
    filter(VideoAnalysisActions.predictEnvironment.match),
    map((action) => action.payload),
    concatMap((image) => predictEnvironmentFromImage(image, dependencies.smoEnvironmentImageClassifier!)),
    filter((environment) => environment !== SmoEnvironment.none),
    distinctUntilChanged(),
    switchMap((environment) => [
      VideoAnalysisActions.setPredictedEnvironment(environment),
      WidgetFrontActions.updateEnvironment(environment)
    ])
  );
}

function predictEnvironmentFromImage(
  image: HTMLImageElement,
  imageClassifier: ImageClassifier<SmoEnvironment>
): Observable<SmoEnvironment> {
  return imageClassifier.predict(image);
}

export default combineEpics(predictEnvironment);
